export default "__VITE_ASSET__92f2e2d8__"